import { UpCs } from './type';

export function getDiscountedPrice(up_c_s: UpCs, lang: string): number {
  if (lang === 'kr') return up_c_s.discounted_price;
  if (lang === 'en') return up_c_s.discounted_price_en;
  if (lang === 'jp') return up_c_s.discounted_price_jp;
  return 0;
}

export const handlePrint = () => {
  const width = 800;
  const height = 600;
  const left = Math.round(window.screenX + (window.innerWidth - width) / 2);
  const top = Math.round(window.screenY + (window.innerHeight - height) / 2);

  const windowFeatures = `
    width=${width},
    height=${height},
    left=${left},
    top=${top},
    resizable=yes,
    scrollbars=yes,
    status=no,
    menubar=no,
    toolbar=no,
    location=no
  `.replace(/\s/g, '');

  try {
    const printWindow = window.open('', `print_window_${Date.now()}`, windowFeatures);
    if (!printWindow) {
      alert('팝업이 차단되어 있습니다. 팝업 차단을 해제해주세요.');
      return;
    }

    // 현재 문서에서 프린트할 영역만 복사
    printWindow.document.write(`
      <html>
        <head>
          <title>인쇄</title>
          ${document.head.innerHTML}
        </head>
        <body>
          ${document.querySelector('.print-area')?.innerHTML || document.body.innerHTML}
          <button onclick="window.close()" style="position: fixed; top: 20px; right: 20px; padding: 8px 16px;">닫기</button>
        </body>
      </html>
    `);
    printWindow.document.close();
  } catch (error) {
    console.error('Print window error:', error);
    alert('새 창을 열 수 없습니다. 브라우저 설정을 확인해주세요.');
  }
};
